import { render, staticRenderFns } from "./FeatureInfosPanel.vue?vue&type=template&id=3088fb40&scoped=true"
import script from "./FeatureInfosPanel.vue?vue&type=script&lang=ts"
export * from "./FeatureInfosPanel.vue?vue&type=script&lang=ts"
import style0 from "./FeatureInfosPanel.vue?vue&type=style&index=0&id=3088fb40&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3088fb40",
  null
  
)

export default component.exports